import {
  CreateProductHistoryEntity,
  ProductHistoryEntity,
} from '@/pages/privatePages/producthistory/types';
import { BaseService } from './base.service';

class ProductHistoryService extends BaseService<
  'productHistory',
  ProductHistoryEntity,
  CreateProductHistoryEntity
> {
  constructor() {
    super('product-history');
  }
}
export const productHistoryService = new ProductHistoryService();
